import { __spreadArray } from "tslib";
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isToday from 'dayjs/plugin/isToday';
import { reduce } from '../../utils/polyfills';
import { DeviceTypeEnum, DimensionNameEnum, DimensionTimeRangeEnum, } from '../../types/campaignsJson';
import { getDevice, getWindowLocation } from '../../utils/common';
import { isLocationMatched, isScheduleMatched, isUrlMatch, isReferrerMatch, hasNotOperator, } from './utils';
dayjs.extend(isBetween);
dayjs.extend(isToday);
export function doesPageMatch(item) {
    var href = getWindowLocation();
    return isLocationMatched(href, item.pageMatches);
}
export function doesScheduleMatch(item) {
    var dateTimeNow = new Date().toISOString();
    return isScheduleMatched(dateTimeNow, item.schedule);
}
export function doesDeviceMatch(item) {
    var device = getDevice();
    return item.device === DeviceTypeEnum.ALL || item.device === device;
}
function doesDimensionUrlMatch(item) {
    if (item.name !== DimensionNameEnum.url) {
        return true;
    }
    var type = item.type, match = item.match;
    var href = getWindowLocation();
    return isUrlMatch(href, { type: type, match: match });
}
function doesDimensionReferrerMatch(item) {
    if (item.name !== DimensionNameEnum.referrer) {
        return true;
    }
    var referrer = document.referrer;
    return isReferrerMatch(referrer, item);
}
function doesDimensionOSMatch(item) {
    if (item.name !== DimensionNameEnum.os_type) {
        return true;
    }
    var match = item.match, op = item.op;
    var userAgent = window.navigator.userAgent;
    var result = userAgent
        .toLocaleLowerCase()
        .includes(match.toLocaleLowerCase());
    return hasNotOperator(op) ? !result : result;
}
function getLocations(item, data) {
    return Object.keys(data).filter(function (url) { return isUrlMatch(url, item); });
}
function getSessions(locations, storage, dimension, lastSession) {
    var _a;
    var callbackFn = function (acc, location) {
        var _a;
        var currentSessions = ((_a = storage === null || storage === void 0 ? void 0 : storage[location]) === null || _a === void 0 ? void 0 : _a.sessions) || [];
        return __spreadArray(__spreadArray([], acc, true), currentSessions, true);
    };
    var allSessions = reduce(locations, callbackFn, []);
    var duration = (_a = dimension === null || dimension === void 0 ? void 0 : dimension.options) === null || _a === void 0 ? void 0 : _a.duration;
    switch (duration.type) {
        case DimensionTimeRangeEnum.all:
            return allSessions;
        case DimensionTimeRangeEnum.latest: {
            return allSessions.filter(function (session) {
                return dayjs(session.start).isAfter(dayjs(lastSession));
            });
        }
        case DimensionTimeRangeEnum.today: {
            return allSessions.filter(function (session) { return dayjs(session.start).isToday(); });
        }
        case DimensionTimeRangeEnum.past_week: {
            var weekAgo_1 = dayjs().subtract(7, 'day').startOf('day');
            return allSessions.filter(function (session) {
                return dayjs(session.start).isAfter(weekAgo_1);
            });
        }
        case DimensionTimeRangeEnum.past_month: {
            var monthAgo_1 = dayjs().subtract(30, 'day').startOf('day');
            return allSessions.filter(function (session) {
                return dayjs(session.start).isAfter(monthAgo_1);
            });
        }
        case DimensionTimeRangeEnum.before: {
            return allSessions.filter(function (session) {
                return dayjs(session.start).isBefore(dayjs(duration.schedule.start));
            });
        }
        case DimensionTimeRangeEnum.after: {
            return allSessions.filter(function (session) {
                return dayjs(session.start).isAfter(dayjs(duration.schedule.start));
            });
        }
        case DimensionTimeRangeEnum.time_range: {
            return allSessions.filter(function (session) {
                return dayjs(session.start).isBetween(dayjs(duration.schedule.start), dayjs(duration.schedule.end));
            });
        }
        default:
            return [];
    }
}
function doesDimensionNumberOfVisitMatch(item, data, lastSession) {
    var _a, _b, _c;
    if (item.name !== DimensionNameEnum.number_of_visit) {
        return true;
    }
    var locations = getLocations(item, data);
    var sessions = getSessions(locations, data, item, lastSession);
    return sessions.length >= ((_c = (_b = (_a = item.options) === null || _a === void 0 ? void 0 : _a.trigger) === null || _b === void 0 ? void 0 : _b.visit) === null || _c === void 0 ? void 0 : _c.total);
}
function doesDimensionTimeOnPageMatch(_) {
    return true;
}
export function doesDimensionsMatch(item, sessions, lastSession) {
    var _a;
    if (!((_a = item.dimensions) === null || _a === void 0 ? void 0 : _a.length)) {
        return true;
    }
    try {
        return !!item.dimensions.some(function (dimension) {
            var result = dimension
                .filter(doesDimensionUrlMatch)
                .filter(doesDimensionReferrerMatch)
                .filter(doesDimensionOSMatch)
                .filter(function (el) {
                return doesDimensionNumberOfVisitMatch(el, sessions, lastSession);
            })
                .filter(doesDimensionTimeOnPageMatch);
            return result.length === dimension.length;
        });
    }
    catch (e) {
        return false;
    }
}
